import gradient_props from "libs/gradient_props";

const props_enum = {
  0: gradient_props.red,
  1: gradient_props.neon_green,
  2: gradient_props.red,
  3: gradient_props.blue,
  4: gradient_props.red,
};

const props_obj = {
  error: gradient_props.red,
  success: gradient_props.green,
};

const getGradientPropsByStatus = (status, theme) => {
  const { time, seed, colors } =
    typeof status === "number" ? props_enum[status] : props_obj[status];

  const themeColors = colors[theme];

  return { time, seed, colors: themeColors };
};

export default getGradientPropsByStatus;
